import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable({
  providedIn: 'root',
})
export class NoMaintenanceGuard implements CanActivate {
  constructor(private maintenanceService: MaintenanceService, private router: Router) {}

  public async canActivate(next: ActivatedRouteSnapshot): Promise<any> {
    if (await this.maintenanceService.isUnderMaintenance()) {
      console.log(`Cannot activate route ${next.url} in maintenance mode`);
      this.maintenanceService.saveUrl(this.router.routerState.snapshot.url);
      return this.router.parseUrl('/maintenance');
    } else {
      return true;
    }
  }
}
